<script>
import {
  newsLettersSelectorEmits,
  newsLettersSelectorProps,
  useNewsLetterSelector
} from "./mixin";

import Button from "@/components/atoms/button";
import Form from "@/components/molecules/form";
import StateOverlay from "@/components/molecules/state-overlay";
import Alert from "@/components/molecules/alert";
import List from "@/components/molecules/list";
import ListItem from "@/components/molecules/list/list-item";
import Icon from "@/components/atoms/icon";
import { isMagasinBascule } from "@/utils/magasin";

export default {
  name: "NewsletterSelectorMobile",
  components: {
    Form,
    Button,
    StateOverlay,
    Alert,
    List,
    ListItem,
    Icon
  },
  props: { ...newsLettersSelectorProps() },
  emits: [...newsLettersSelectorEmits()],
  setup(props, context) {
    const {
      v$,
      isSuccess,
      isLoadingComputed,
      selectedMines,
      selectedProposals,
      newsLetters,
      addToNewsletters,
      removeFromNewsletters,
      init,
      save
    } = useNewsLetterSelector(props, context);

    onMounted(() => {
      init();
    });

    return {
      v$,
      isSuccess,
      isLoadingComputed,
      selectedMines,
      selectedProposals,
      newsLetters,
      addToNewsletters,
      removeFromNewsletters,
      save,
      init
    };
  },
  data() {
    return {
      hasChanged: false
    };
  },
  methods: {
    isChecked(magId) {
      return this.newsLetters.some((nl) => nl.id === magId);
    },
    changeStatus(magId) {
      this.hasChanged = true;
      if (this.isChecked(magId)) {
        this.selectedMines = [magId];
        this.removeFromNewsletters();
      } else {
        this.selectedProposals = [magId];
        this.addToNewsletters();
      }
    },
    submit() {
      this.hasChanged = false;
      this.save();
    }
  }
};
</script>

<template>
  <Form
    :error="error"
    @submit.prevent="submit()"
  >
    <StateOverlay
      :is-loading="isLoadingComputed"
      overlay
    >
      <Alert
        v-if="hasChanged"
        has-icon
        icon-position="left"
        icon-name="info-circle"
        icon-size="lg"
        icon-color="primary-light"
        radius="md"
        class="u-mt-sm u-mb-sm"
      >
        <p>Pensez à enregistrer vos modifications pour qu'elles soient prises en compte.</p>
      </Alert>
      <List class="c-newsletter-selector--liste">
        <template v-for="magasin in magasins">
          <ListItem
            v-if="isChecked(magasin.id) || !isMagasinBascule(magasin)"
            :key="magasin.id"
            :value="magasin.id"
            class="c-newsletter-selector--liste-item"
          >
            <Button
              class="c-newsletter-selector--liste-item-button"
              @click="changeStatus(magasin.id)"
            >
              <div class="u-flex u-flex-align-center">
                <div class="c-newsletter-selector--liste-item-icon u-flex u-flex-align-center u-flex-justify-center">
                  <Icon
                    v-if="isChecked(magasin.id)"
                    variant="primary"
                    name="check"
                  />
                </div>
                {{ magasin.attributes.cp }} - Magasin {{ magasin.attributes.magasin }}
              </div>
            </Button>
          </ListItem>
        </template>
      </List>
      <p
        v-if="isSuccess"
        class="u-text-center u-color-success u-mt-sm u-flex u-flex-justify-center u-flex-align-center"
      >
        <Icon
          name="check"
          size="md"
          variant="success"
        />
        <span class="u-ml-sm">Vos préférences de newsletters ont bien été enregistrées</span>
      </p>
      <div class="u-mt-sm u-text-center">
        <Button
          variant="primary"
          radius="full"
          size="md"
          type="submit"
          value="Mettre à jour mes newsletters"
        />
      </div>
    </StateOverlay>
  </Form>
</template>

<style lang="scss" scoped>
.c-newsletter-selector--liste {
  height: 50rem;
  overflow-y: scroll;
  padding: 0 spacing(sm);
  border: 2px solid color(grey-6);
}
.c-newsletter-selector--liste-item {
  height: 5rem;
  border-bottom: 2px solid color(grey-6);
  &:last-child {
    border-bottom: none;
  }
}
.c-newsletter-selector--liste-item-button {
  width: 100%;
  height: 100%;
  justify-content: left;
}

.c-newsletter-selector--liste-item-icon {
  width: 5rem;
}
</style>
